import React from 'react';
import Marker from 'react-image-marker';
import { Box, Button, Checkbox, FormControlLabel, Grid, Slider, TextField, Typography } from '@mui/material';
import { FaClipboardCheck } from 'react-icons/fa';
import EsquemaImg from '../assets/Esquema.jpg';

const RECEPCION_ITEMS = [
  "Espejo Izquierdo", "Espejo Derecho", "Vidrios", "Radio",
  "Pantalla", "Encendedor", "Antena", "Cont. de Puertas", "Cargador Cel.", "Triángulos",
  "Cubresol", "Herramientas", "Gato", "Llanta de Refacción", "Faros/Luces",
  "Tapa de Gasolina", "Placas", "Tapetes", "Extintor", "Llave de Tuercas"
];

const RecepcionVehiculo = ({ form, onChange, onCheck, onMarkerChange, esquemaRef }) => {

  const col1 = RECEPCION_ITEMS.slice(0, 10);
  const col2 = RECEPCION_ITEMS.slice(10);

  return (
    <div className="card card-app mb-4">
      <div className="card-header-app"><FaClipboardCheck /> RECEPCIÓN DEL VEHÍCULO</div>
      <div className="card-body">
        <Grid container spacing={2}>
          {/* Columna izquierda: checks + botones */}
          <Grid item xs={12} md={6}>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6}>
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                  {col1.map((item, i) => (
                    <FormControlLabel
                      key={`item1-${i}`}
                      control={
                        <Checkbox
                          name={item}
                          checked={!!form.recepcion[item]}
                          onChange={onCheck}
                        />
                      }
                      label={item}
                    />
                  ))}
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                  {col2.map((item, i) => (
                    <FormControlLabel
                      key={`item2-${i}`}
                      control={
                        <Checkbox
                          name={item}
                          checked={!!form.recepcion[item]}
                          onChange={onCheck}
                        />
                      }
                      label={item}
                    />
                  ))}
                </Box>
              </Grid>
            </Grid>

            {/* Botones debajo de los checks */}
            <Box sx={{ mt: 2, display: 'flex', gap: 1 }}>
              <Button
                variant="contained"
                color="success"
                onClick={() => {
                  const nuevos = {};
                  RECEPCION_ITEMS.forEach(item => {
                    nuevos[item] = true;
                  });
                  onChange({ target: { name: 'recepcion', value: nuevos } });
                }}
              >
                ✅ Marcar todos
              </Button>

              <Button
                variant="outlined"
                color="inherit"
                onClick={() => {
                  const nuevos = {};
                  RECEPCION_ITEMS.forEach(item => {
                    nuevos[item] = false;
                  });
                  onChange({ target: { name: 'recepcion', value: nuevos } });
                }}
              >
                ❌ Quitar todos
              </Button>
            </Box>
          </Grid>

          {/* Columna derecha: esquema */}
          <Grid item xs={12} md={6} sx={{ textAlign: 'center' }}>
            <Typography variant="body2" sx={{ fontWeight: 600, color: '#083a94', mb: 1 }}>
              Esquema del vehículo
            </Typography>
            <div
              ref={esquemaRef}
              style={{
                maxWidth: '100%',
                width: '280px',           // 👈 Tamaño fijo más pequeño
                margin: '0 auto',
                border: '1px solid #ccc'
              }}
            >
              <Marker
                src={EsquemaImg}
                markers={form.marcas || []}
                onAddMarker={onMarkerChange}
              />
            </div>

            <Box sx={{ textAlign: 'center', mt: 2, display: 'flex', justifyContent: 'center', gap: 1 }}>
              <Button
                size="small"
                variant="outlined"
                color="warning"
                onClick={() => onMarkerChange('removeLast')}
              >
                Quitar última marca
              </Button>
              <Button
                size="small"
                variant="outlined"
                color="error"
                onClick={() => onMarkerChange('clear')}
              >
                Limpiar todas
              </Button>
            </Box>
          </Grid>
        </Grid>

        {/* Sección inferior: gasolina y kilometraje */}
        <Grid container spacing={2} sx={{ mt: 3 }}>
          <Grid item xs={12} md={6}>
            <TextField
              label="Kilometraje"
              type="number"
              name="kilometraje"
              value={form.kilometraje}
              onChange={onChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="body2" sx={{ fontWeight: 600, color: '#083a94' }}>
              Gasolina
            </Typography>
            <Slider
              name="gasolina"
              min={0}
              max={100}
              value={Number(form.gasolina)}
              onChange={(e, value) => onChange({ target: { name: 'gasolina', value } })}
            />
            <Typography variant="body2" sx={{ textAlign: 'right' }}>{form.gasolina}%</Typography>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default RecepcionVehiculo;
